/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
* personeel_label.ts
* 20-5-2025 - Jelmer Jellema - Spin in het Web B.V.
*
* labels bij personeel, voor filteren en indelen
*/

import {Basemodel, ModelField, OwnerField} from './basemodel';
import {Personeel} from './personeel';

export class PersoneelLabel extends Basemodel {
    static table = 'personeelvast_label';
    static defaultOrder = ['label'];
    // static loglevel: string = 'debug';
    @ModelField() override id: number = null;
    @OwnerField() personeelvast_id: number;
    @ModelField() label: string;


    /**
     * Typing van eigenaar
     */
    public override _owner: Personeel = null;
}
